import {
  ONLINE_STORE_CLOSE_DISCONNECT_SHOP_MODAL,
  ONLINE_STORE_CLOSE_GO_STORE_UNACTIVATED_MODAL,
  ONLINE_STORE_CLOSE_OUTLET_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_DONE_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_IN_SYNC_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_RESULT_MODAL,
  ONLINE_STORE_CONNECT_GOOGLE_SHOP,
  ONLINE_STORE_DISCONNECT_SHOP,
  ONLINE_STORE_PAGE_REQUEST,
  ONLINE_STORE_FINISH_PAGE_REQUEST,
  ONLINE_STORE_LOADING_PAGE_REQUEST,
  ONLINE_STORE_SET_SHOP_DETAIL_PRODUCTS,
  ONLINE_STORE_SET_SHOP_DETAIL,
  ONLINE_STORE_SET_SHOPS,
  ONLINE_STORE_SHOP_DETAIL_PRODUCTS_REQUEST,
  ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL,
  ONLINE_STORE_SHOW_GO_STORE_UNACTIVATED_MODAL,
  ONLINE_STORE_SHOW_OUTLET_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_DONE_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_IN_SYNC_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_RESULT_MODAL,
  ONLINE_STORE_START_FACEBOOK_SIGN_IN_FLOW,
  ONLINE_STORE_START_POST_SYNCING_PRODUCT_FLOW,
  ONLINE_STORE_START_SELECT_OUTLET_FLOW,
  ONLINE_STORE_START_SYNCING_PRODUCT_FLOW,
  ONLINE_STORE_START_SYNCING_PRODUCT_VALIDATION_FLOW,
  ONLINE_STORE_OPEN_CONNECT_GOOGLE_EMAIL_MODAL,
  ONLINE_STORE_CLOSE_CONNECT_GOOGLE_EMAIL_MODAL,
  ONLINE_STORE_CONNECT_GOOGLE_EMAIL,
  ONLINE_STORE_START_EXPORT_PRODUCT_FLOW,
  ONLINE_STORE_START_POST_EXPORT_PRODUCT_FLOW,
  ONLINE_STORE_SET_PRODUCT_EXPORT_ID,
  ONLINE_STORE_FACEBOOK_MODAL_OPENED,
  ONLINE_STORE_FACEBOOK_MODAL_CLOSED,
  ONLINE_STORE_SELECT_OUTLET,
  ONLINE_STORE_SHOW_FACEBOOK_DOMAIN_VERIFICATION_MODAL,
  ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL,
  ONLINE_STORE_SET_BUSINESS_INFO,
  ONLINE_STORE_PATCH_META_TAG,
  ONLINE_STORE_ON_CHANGE_FACEBOOK_DOMAIN_VERIFICATION,
  ONLINE_STORE_SHOW_UPDATE_REQUIRED_MODAL,
  ONLINE_STORE_CLOSE_UPDATE_REQUIRED_MODAL,
  ONLINE_STORE_SHOW_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL,
  ONLINE_STORE_CLOSE_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL,
  ONLINE_STORE_SELECT_OUTLET_INFO,
} from './constants';

export function startSyncingProductValidationFlow(shopId, viewOnly) {
  return {
    type: ONLINE_STORE_START_SYNCING_PRODUCT_VALIDATION_FLOW,
    payload: { shopId, viewOnly },
  };
}

export function startProductExportFlow(shopId) {
  return {
    type: ONLINE_STORE_START_EXPORT_PRODUCT_FLOW,
    payload: { shopId },
  };
}

export function startPostProductExportFlow(shopId) {
  return {
    type: ONLINE_STORE_START_POST_EXPORT_PRODUCT_FLOW,
    payload: { shopId },
  };
}

export function setProductExportId(exportId) {
  return {
    type: ONLINE_STORE_SET_PRODUCT_EXPORT_ID,
    payload: { exportId },
  };
}

export function startPostSyncingProductFlow() {
  return {
    type: ONLINE_STORE_START_POST_SYNCING_PRODUCT_FLOW,
  };
}

export function startSyncingProductFlow(shopId, viewOnly, shopDetail) {
  return {
    type: ONLINE_STORE_START_SYNCING_PRODUCT_FLOW,
    payload: { shopId, viewOnly, shopDetail },
  };
}

export function setShopDetail(payload) {
  return {
    type: ONLINE_STORE_SET_SHOP_DETAIL,
    payload,
  };
}

export function setShopDetailProducts(page, completed, data) {
  return {
    type: ONLINE_STORE_SET_SHOP_DETAIL_PRODUCTS,
    payload: { page, completed, data },
  };
}

export function shopDetailProductsRequest(
  shopId,
  page,
  status = 'ALL',
  clearAll = false
) {
  return {
    type: ONLINE_STORE_SHOP_DETAIL_PRODUCTS_REQUEST,
    payload: { shopId, page, status, clearAll },
  };
}

export function showSyncingProductEmptyProductModal() {
  return {
    type: ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL,
  };
}

export function closeSyncingProductEmptyProductModal() {
  return {
    type: ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL,
  };
}

export function showSyncingProductEmptySyncedModal() {
  return {
    type: ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL,
  };
}

export function closeSyncingProductEmptySyncedModal() {
  return {
    type: ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL,
  };
}

export function showGoStoreUnActivatedModal() {
  return {
    type: ONLINE_STORE_SHOW_GO_STORE_UNACTIVATED_MODAL,
  };
}

export function closeGoStoreUnActivatedModal() {
  return {
    type: ONLINE_STORE_CLOSE_GO_STORE_UNACTIVATED_MODAL,
  };
}

export function showGoStoreNotNationWideShippingModal() {
  return {
    type: ONLINE_STORE_SHOW_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL,
  };
}

export function closeGoStoreNotNationWideShippingModal() {
  return {
    type: ONLINE_STORE_CLOSE_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL,
  };
}

export function showSyncingProductInSyncModal() {
  return {
    type: ONLINE_STORE_SHOW_SYNCING_PRODUCT_IN_SYNC_MODAL,
  };
}

export function closeSyncingProductInSyncModal() {
  return {
    type: ONLINE_STORE_CLOSE_SYNCING_PRODUCT_IN_SYNC_MODAL,
  };
}

export function showSyncingProductResultModal() {
  return {
    type: ONLINE_STORE_SHOW_SYNCING_PRODUCT_RESULT_MODAL,
  };
}

export function closeSyncingProductResultModal() {
  return {
    type: ONLINE_STORE_CLOSE_SYNCING_PRODUCT_RESULT_MODAL,
  };
}

export function showSyncingProductDoneModal() {
  return {
    type: ONLINE_STORE_SHOW_SYNCING_PRODUCT_DONE_MODAL,
  };
}

export function closeSyncingProductDoneModal() {
  return {
    type: ONLINE_STORE_CLOSE_SYNCING_PRODUCT_DONE_MODAL,
  };
}

export function showOutletModal() {
  return {
    type: ONLINE_STORE_SHOW_OUTLET_MODAL,
  };
}

export function closeOutletModal() {
  return {
    type: ONLINE_STORE_CLOSE_OUTLET_MODAL,
  };
}

export function pageRequest(channel) {
  return {
    type: ONLINE_STORE_PAGE_REQUEST,
    payload: { channel },
  };
}

export function startSelectOutletFlow(channel, source) {
  return {
    type: ONLINE_STORE_START_SELECT_OUTLET_FLOW,
    payload: { channel, source },
  };
}

export function setShops(shops) {
  return {
    type: ONLINE_STORE_SET_SHOPS,
    payload: { shops },
  };
}

export function startFacebokSignInFlow({
  outletId,
  outletName,
  source,
  shop,
  outletInfo,
}) {
  return {
    type: ONLINE_STORE_START_FACEBOOK_SIGN_IN_FLOW,
    payload: { outletId, outletName, shop, source, outletInfo },
  };
}

export function loadingPageRequest() {
  return {
    type: ONLINE_STORE_LOADING_PAGE_REQUEST,
  };
}

export function finishPageRequest() {
  return {
    type: ONLINE_STORE_FINISH_PAGE_REQUEST,
  };
}

export function showDisconnectShopModal(shop, outlet) {
  return {
    type: ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL,
    payload: {
      shop,
      outlet,
    },
  };
}

export function closeDisconnectShopModal() {
  return {
    type: ONLINE_STORE_CLOSE_DISCONNECT_SHOP_MODAL,
  };
}

export function disconnectShop(shop, outlet) {
  return {
    type: ONLINE_STORE_DISCONNECT_SHOP,
    payload: { shop, outlet },
  };
}

export function connectGoogleShop({ outletId, outletName, source }) {
  return {
    type: ONLINE_STORE_CONNECT_GOOGLE_SHOP,
    payload: { outletId, outletName, source },
  };
}

export function openConnectGoogleEmailModal(shop) {
  return {
    type: ONLINE_STORE_OPEN_CONNECT_GOOGLE_EMAIL_MODAL,
    payload: { shop },
  };
}

export function closeConnectGoogleEmailModal() {
  return {
    type: ONLINE_STORE_CLOSE_CONNECT_GOOGLE_EMAIL_MODAL,
  };
}

export function connectGoogleEmail(shop, email) {
  return {
    type: ONLINE_STORE_CONNECT_GOOGLE_EMAIL,
    payload: { shop, email },
  };
}

export function facebookModalOpened() {
  return {
    type: ONLINE_STORE_FACEBOOK_MODAL_OPENED,
  };
}

export function facebookModalClosed() {
  return {
    type: ONLINE_STORE_FACEBOOK_MODAL_CLOSED,
  };
}

export function selectOutlet({ outletId, outletName, source, channel }) {
  return {
    type: ONLINE_STORE_SELECT_OUTLET,
    payload: {
      outletId,
      outletName,
      source,
      channel,
    },
  };
}

export function selectOutletInfo(outletInfo) {
  return {
    type: ONLINE_STORE_SELECT_OUTLET_INFO,
    payload: {
      outletInfo,
    },
  };
}

export function showFacebookDomainVerificationModal(shop, businessInfo) {
  return {
    type: ONLINE_STORE_SHOW_FACEBOOK_DOMAIN_VERIFICATION_MODAL,
    payload: {
      shop,
      businessInfo,
    },
  };
}

export function closeFacebookDomainVerificationModal() {
  return {
    type: ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL,
  };
}

export function setBusinessInfo(businessInfo) {
  return {
    type: ONLINE_STORE_SET_BUSINESS_INFO,
    payload: { businessInfo },
  };
}

export function patchMetaTag(name, content) {
  return {
    type: ONLINE_STORE_PATCH_META_TAG,
    payload: { name, content },
  };
}

export function onChangeFacebookDomainVerification({ error, step }) {
  return {
    type: ONLINE_STORE_ON_CHANGE_FACEBOOK_DOMAIN_VERIFICATION,
    payload: { error, step },
  };
}

export function showUpdateRequiredModal() {
  return {
    type: ONLINE_STORE_SHOW_UPDATE_REQUIRED_MODAL,
  };
}

export function closeUpdateRequiredModal() {
  return {
    type: ONLINE_STORE_CLOSE_UPDATE_REQUIRED_MODAL,
  };
}
